import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-style",
  "use": "icon-style-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-style\">\n  <path d=\"M864 518H506.5c-3.8 0-7.1-2.7-7.9-6.5l-34.7-166.7c-1.2-5.7-6.2-9.8-12-9.8h-74.7c-6.7 0-12.2 5.5-12.2 12.2v24.9c0 6.7 5.5 12.2 12.2 12.2H399l30.9 148.4c1.2 5.7 6.2 9.8 12 9.8H864c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8H394.9c-17.7 0-32.4-12.6-35.6-30.1l-36.8-176.3c-0.7-3.4-3.7-5.9-7.2-5.9H144c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h171.3c17.7 0 32.4 12.6 35.6 30.1l36.8 176.3c0.7 3.4 3.7 5.9 7.2 5.9H864c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8z\" fill=\"currentColor\" p-id=\"8427\" />\n  <path d=\"M760 888c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96z m0-128c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32z\" fill=\"currentColor\" p-id=\"8428\" />\n  <path d=\"M348 888c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96z m0-128c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32z\" fill=\"currentColor\" p-id=\"8429\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/style.svg
// module id = JB/Y
// module chunks = 117